export const VBroadcast = () => import(/* webpackChunkName: 'broadcast' */ './broadcast/src/main.vue')
